import { AppSidebar } from "@/components/layout/AppSidebar";
import { BetaBadge } from "@/components/BetaBadge";
import { BreadcrumbProvider } from "@/components/layout/Breadcrumbs";
import { Header } from "@/components/layout/Header";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAppSettings } from "@/hooks/use-app-settings";
import { Outlet } from "react-router-dom";

export function AppLayout() {
  const { settings } = useAppSettings();

  return (
    <SidebarProvider>
      <BreadcrumbProvider>
        {settings.showBetaBadge && <BetaBadge />}
        <div className="flex min-h-screen w-full max-w-full flex-col bg-background overflow-x-hidden">
          <AppSidebar />
          <div className="flex flex-col sm:gap-6 sm:py-6 sm:pl-14 w-full max-w-full overflow-x-hidden">
            <Header />
            <main className="grid flex-1 items-start gap-6 p-4 sm:px-8 sm:py-0 md:gap-10 w-full max-w-full overflow-x-hidden">
              <Outlet />
            </main>
          </div>
        </div>
      </BreadcrumbProvider>
    </SidebarProvider>
  );
}

